<template>
	<nav class="navbar navbar-default">
		<div class="container">
			<!-- Brand and toggle get grouped for better mobile display -->
			<div class="navbar-header">
				<button
						type="button"
						:class="showNav ? 'navbar-toggle active' : 'navbar-toggle collapsed'"
						aria-expanded="false"
						@click="showNav=!showNav"
					>
					<span class="sr-only">Toggle navigation</span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
					<span class="icon-bar"></span>
				</button>
			</div>
			<b-collapse v-model="showNav" class="collapse navbar-collapse" id="admin-navbar-collapse">
				<!-- Collect the nav links, forms, and other content for toggling -->
				<ul class="nav navbar-nav navbar-left">
					<li><router-link to="/admin/projects">Projects</router-link></li>
					<li><router-link to="/admin/tags">Tags</router-link></li>
					<li><router-link to="/admin/pages">Pages</router-link></li>
					<li><router-link to="/admin/downloads">Downloads</router-link></li>
				</ul>
				<ul class="nav navbar-nav navbar-right">
					<li><router-link to="/admin/users">Users</router-link></li>
				</ul>
				<!-- drop down internal shadow -->
				<div class="nav-grad"/>
			</b-collapse>
		</div>
	</nav>
</template>

<style lang="less" scoped>
	.navbar-left {
		margin-left:-15px;
	}
</style>


<script>
export default {
	data() {
		return {
			showNav: false
		};
	}
};
</script>
